import React from "react";
import PdfViewer from "../../PdfViewer";

const FaseNegociacionCierre = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/06-fase-negociacion-y-cierre.pdf`;
  /*const pdfUrl = "/pdf/06-fase-negociacion-y-cierre.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Fase de Negociación y Cierre</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default FaseNegociacionCierre;
